<template>
  <el-dialog :title="'材料账户明细 - ' + userName" :visible.sync="isVisible" width="85%" @close="handleClose">
    <!-- 时间范围筛选 -->
    <div class="detail-filter">
      <el-date-picker v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
        end-placeholder="结束时间" value-format="timestamp" :default-time="['00:00:00', '23:59:59']"
        size="small" @change="handleTimeChange" />
    </div>
    <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
      @search-change="searchChange" @refresh-change="refreshChange" @size-change="pageSizeChange"
      @current-change="pageChange">
      <template slot-scope="scope" slot="menu">
        <el-button type="text" icon="el-icon-delete" size="small" @click="handleDelete(scope.row)">删除</el-button>
      </template>
      <!-- 自定义操作金额列样式 -->
      <template slot-scope="{ row }" slot="amount">
        <span :style="{ color: row.amount > 0 ? '#67C23A' : row.amount < 0 ? '#F56C6C' : '' }">
          {{ formatAmount(row.amount) }}
        </span>
      </template>
    </avue-crud>
  </el-dialog>
</template>

<script>
import { materialAccountV2DetailTableOption } from "@/const/work/waterProof/materialAccountV2Option";
import { getMaterialAccountLogDetail, deleteMaterialAccountLog } from "@/api/work/waterProof/materialAccountV2";

export default {
  name: 'MaterialAccountV2Detail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      required: true
    },
    userName: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
      if (newVal && this.userId) {
        this.resetAndLoad();
      }
    }
  },
  data() {
    return {
      isVisible: this.visible,
      tableOption: materialAccountV2DetailTableOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      // 筛选条件
      timeRange: null,
      searchType: ''
    };
  },
  methods: {
    // 重置并加载
    resetAndLoad() {
      this.page.currentPage = 1;
      this.timeRange = null;
      this.searchType = '';
      this.handleDetailList();
    },

    // 获取明细列表
    handleDetailList() {
      if (!this.userId) return;
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage, // 后端page从1开始
        size: this.page.pageSize
      };
      // 操作类型筛选
      if (this.searchType) {
        params.type = this.searchType;
      }
      // 时间范围筛选
      if (this.timeRange && this.timeRange.length === 2) {
        params.startTime = this.timeRange[0];
        params.endTime = this.timeRange[1];
      }
      getMaterialAccountLogDetail(this.userId, params)
        .then(res => {
          this.tableLoading = false;
          if (res.code === '200') {
            const data = JSON.parse(res.data) || {};
            this.tableData = data.rows || [];
            this.page.total = data.total || 0;
          } else {
            this.tableData = [];
            this.page.total = 0;
            this.$message.error('获取材料账户明细失败');
          }
        })
        .catch(() => {
          this.tableLoading = false;
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户明细异常');
        });
    },

    // 格式化金额
    formatAmount(amount) {
      if (amount == null) return '0.00';
      const val = Number(amount);
      const str = val.toFixed(2);
      if (val > 0) return '+' + str;
      return str;
    },

    // 时间范围变化
    handleTimeChange() {
      this.page.currentPage = 1;
      this.handleDetailList();
    },

    // 搜索（操作类型筛选）
    searchChange(params, done) {
      this.searchType = params.type || '';
      this.page.currentPage = 1;
      this.handleDetailList();
      done && done();
    },

    // 删除明细记录
    handleDelete(row) {
      this.$confirm('确定要删除该条记录吗？删除后余额将自动重算。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableLoading = true;
        deleteMaterialAccountLog(row.id).then(res => {
          this.tableLoading = false;
          if (res.code === '200') {
            this.$message.success('删除成功');
            this.handleDetailList();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        }).catch(() => {
          this.tableLoading = false;
          this.$message.error('删除异常');
        });
      }).catch(() => {});
    },

    // 分页
    pageChange(page) {
      this.page.currentPage = page;
      this.handleDetailList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.handleDetailList();
    },
    refreshChange() {
      this.handleDetailList();
    },

    // 关闭
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-filter {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
</style>
